import React, { useState, useRef } from 'react';
import '../index.css'; // Make sure index.css includes .chat-message-wrapper, .reaction-popup, etc.

const reactions = ['👍', '❤️', '👎', '😂', '❗', '❓'];

function ChatMessage({ fromUser, message, time }) {
  const [reaction, setReaction] = useState(null);
  const [showReactions, setShowReactions] = useState(false);
  const timerRef = useRef(null);

  // Long press for mobile
  const handleTouchStart = () => {
    timerRef.current = setTimeout(() => setShowReactions(true), 400);
  };

  const handleTouchEnd = () => {
    clearTimeout(timerRef.current);
  };

  // Hover logic for desktop
  const handleMouseEnter = () => {
    setShowReactions(true);
  };

  const handleMouseLeave = () => {
    setShowReactions(false);
  };

  const handleReactionClick = (emoji) => {
    setReaction(emoji);
    setShowReactions(false);
  };

  return (
    <div
      className={`chat-message-wrapper ${fromUser ? 'user' : 'solace'}`}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      onTouchStart={handleTouchStart}
      onTouchEnd={handleTouchEnd}
    >
      <div className={`chat-message ${fromUser ? 'user-message' : 'ai-message'}`}>
        {message}
        {reaction && <span className="chat-reaction-badge">{reaction}</span>}
      </div>

      <div className="message-time">
        {new Date(time).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}
      </div>

      {showReactions && (
        <div className="reaction-popup">
          {reactions.map((emoji) => (
            <button
              key={emoji}
              className="reaction-btn"
              onClick={() => handleReactionClick(emoji)}
            >
              {emoji}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}

export default ChatMessage;
